import superMeta from '../_AR_CAT/metaArCatNode.mjs'

export default {
    ...superMeta,
    mapProp: 'dcMap',
    name: '数据控件',
    type: 'UI_DC',
    textProp: 'dcTitle',
}
